<!-- 布局组件 -->
<template>
  <div class="app-container">
    <Navbar :settings="settings" v-if="isReady" />
    <div class="main-content">
      <!-- 确保路由视图正确渲染 -->
      <router-view v-if="isReady"></router-view>
    </div>
    <Footer :settings="settings" v-if="isReady" />
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import Footer from './Footer.vue'
import request from '@/utils/request'
import config from '@/config'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      isReady: false,  // 添加状态控制
      settings: {
        // 添加默认值，防止组件报错
        site_name: '',
        site_logo: '',
        contact_phone: '',
        contact_email: '',
        company_address: '',
        copyright_text: '',
        icp_number: '',
        wechat_qrcode: ''
      }
    }
  },
  methods: {
    async fetchSettings() {
      try {
        const res = await request.get(config.api.settings.public)
        if (res.data) {
          // 检查返回的数据格式
          if (Array.isArray(res.data)) {
            // 如果是数组格式，转换为对象
            const settingsMap = res.data.reduce((acc, item) => {
              if (item.setting_key && item.setting_value !== undefined) {
                acc[item.setting_key] = item.setting_value;
              }
              return acc;
            }, {});
            
            this.settings = {
              ...this.settings,
              ...settingsMap
            };
          } else if (typeof res.data === 'object') {
            // 如果已经是对象格式，直接使用
            this.settings = {
              ...this.settings,
              ...res.data
            };
          }
          
          console.log('最终的设置数据:', this.settings);
        } else {
          console.warn('接口返回的数据为空');
        }
        this.isReady = true;
      } catch (error) {
        console.error('获取网站设置失败:', error);
        this.isReady = true;
      }
    }
  },
  async created() {
    await this.fetchSettings()
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style> 